export const meetingTypeSchema = {
	schema: {
		title: 'meeting type schema',
		description: 'Meeting Type Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			meeting_type_id: {
				type: 'string',
			},
			meeting_type_name: {
				type: 'string',
			},
			meeting_type_sfid: {
				type: 'string',
			},
			meeting_module: {
				type: 'string',
			},
		},
		required: ['id', 'meeting_type_id', 'meeting_type_name', 'meeting_type_sfid', 'meeting_module'],
	},
};
